import React, { useState } from 'react';
import { actions, formatColumnTitle, MOBILE_ROLES_MODEL } from '../Model/AllowedModules';
import { useTranslation } from 'react-i18next';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import { CustomCheckbox } from '../../../../../components/CustomCheckbox';
import CustomTooltip from '../../../../../components/CustomTooltip';
import {
    IconCheckbox,
    IconCheckboxChecked,
    IconCheckboxUnchecked,
} from '../../../../../components/buttons/IconButtons';
import { handleSelectAllPermissions, isAllPermissionsSelected } from './CommonsPermissions';

/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */

const MobileRolesApp = ({ mobile, selectedPermissions, setSelectedPermissions, readOnly }) => {
    const { t } = useTranslation();
    const [selectedInnerView, setSelectedInnerView] = useState(MOBILE_ROLES_MODEL[0]?.id);

    const tableId = 'tbl_mra_table';

    const handleStepSelectedInnerView = (tab) => {
        setSelectedInnerView(tab);
    };
    const selectedRole = MOBILE_ROLES_MODEL.find((item) => item.id === selectedInnerView);
    const permissions = (mobile || []).filter(
        (permission) =>
            permission.moduleId === selectedRole?.id ||
            selectedRole?.children?.some((child) => child.id === permission.moduleId),
    );
    const standardColumns = actions.filter((action) =>
        permissions.some((permission) => permission.name.includes(action)),
    );

    const customColumns = permissions
        .filter((permission) => !actions.some((action) => permission.name.includes(action)))
        .map((permission) => permission.name);

    const columns = [...standardColumns, ...customColumns];
    const thead = [
        <CustomTh tableId={tableId} key={'module'}>
            {''}
        </CustomTh>,

        ...columns.map((column) => (
            <CustomTh tableId={tableId} key={column}>
                <CustomTooltip text={formatColumnTitle(t(column))}>
                    <div className='text-center text-capitalize'>{formatColumnTitle(t(column))}</div>
                </CustomTooltip>
            </CustomTh>
        )),
    ];
    const handleCheckboxChange = (permissionId, checked) => {
        setSelectedPermissions((prev = []) => {
            if (checked) {
                const exists = prev.some((item) => item.id === permissionId);
                if (exists) return prev;
                return [...prev, { id: permissionId }];
            }
            return prev.filter((item) => item.id !== permissionId);
        });
    };

    const tbody = {
        body: (selectedRole?.children?.length ? selectedRole.children : [selectedRole]).map((child) => {
            const childPermissions = permissions.filter((permission) => permission.moduleId === child.id);

            return (
                <>
                    <CustomTd tableId={tableId}>
                        <p className='fs-12px font-color-text-950 ibl-font-w-600 text-truncate maxw-200px'>
                            {t(child.translation)}
                        </p>
                    </CustomTd>

                    {columns.map((column) => {
                        const permission = childPermissions.find((permission) => {
                            if (actions.includes(column)) {
                                return permission.name.includes(column);
                            }

                            return permission.name === column;
                        });

                        return (
                            <CustomTd tableId={tableId} key={`${child.id}-${column}`}>
                                <div className='d-flex justify-content-center align-items-center'>
                                    <CustomCheckbox
                                        disabled={readOnly}
                                        icon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxUnchecked className='icon-color-general-950' />
                                            )
                                        }
                                        checkedIcon={
                                            !permission ? (
                                                <IconCheckbox />
                                            ) : (
                                                <IconCheckboxChecked className='icon-color-shades-800' />
                                            )
                                        }
                                        checked={selectedPermissions.some((item) => item.id === permission?.id)}
                                        onChange={(e) => handleCheckboxChange(permission?.id, e.target.checked)}
                                    />
                                </div>
                            </CustomTd>
                        );
                    })}
                </>
            );
        }),

        data: selectedRole?.children?.length ? selectedRole.children : [selectedRole],
    };

    const selectedRoleCount = selectedPermissions.filter((permission) =>
        mobile?.some((item) => item.id === permission.id && item.moduleId === selectedRole?.id),
    ).length;

    const currentPermissions = permissions.filter((permission) => permission?.id);

    const isAllChecked = isAllPermissionsSelected(currentPermissions, selectedPermissions);

    const handleSelectAll = (checked) => {
        handleSelectAllPermissions(checked, currentPermissions, setSelectedPermissions);
    };

    return {
        t,
        selectedInnerView,
        handleStepSelectedInnerView,
        selectedRole,
        thead,
        tbody,
        selectedRoleCount,
        isAllChecked,
        handleSelectAll,
    };
};

export default MobileRolesApp;
